import React from 'react'

import { hooks } from '@front/volcanion'

import _ from 'lodash'

const TitlePage = ({ extra, current_page }) => {
  const CLIENT_COMMERCIAL_NAME = hooks.useRelayConstant('CLIENT_COMMERCIAL_NAME')

  const branded = _.compact([CLIENT_COMMERCIAL_NAME, current_page]).join(' | ')
  const title = _.compact([extra, branded]).join(' ')

  return (
    <title>{title}</title>
  )
}

export default TitlePage
